// import node_modules
import * as PropTypes from 'prop-types';
import * as React from 'react';

// import components
import StorylinerImage from './StorylinerImage';

// define components
const MarkdownImage: React.FunctionComponent<{
  hasShadow?: boolean;
  height: number;
  imageId: string;
  title: string;
  width: number;
}> = ({ height, hasShadow, imageId, title, width }) => (
  <div className="storyliner-markdown-image">
    <StorylinerImage
      hasShadow={hasShadow}
      height={height}
      imageId={imageId}
      title={title}
      width={width}
    />
  </div>
);

MarkdownImage.defaultProps = {
  hasShadow: false,
};

MarkdownImage.propTypes = {
  hasShadow: PropTypes.bool,
  height: PropTypes.number.isRequired,
  imageId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
};

export default MarkdownImage;
